import React from "react";

const ComcastCode = () => {
    return (
        <div className="comcast-code-container">
            <div className="comcast-code-text">
                <div>Please mention the code</div>
                <div>when calling to purhcase:</div>
            </div>
            <div className="comcast-code-green">{process.env.REACT_APP_COMCAST_CODE}</div>
        </div>
    );
};

export default ComcastCode;
